<template>
  <div @touchmove="handleTouchMove" id="main_app">
    <van-nav-bar
      :class="{ top_nav_bar: true, no_color: $route.meta.noColor }"
      :title="$route.meta.title"
      :left-arrow="!$route.meta.unback"
      :right-text="$route.meta.rightText"
      @click-left="onClickLeft"
      @click-right="onClickRight"
      v-if="!$route.meta.noheader"
    >
      <template #right>
        <div class="first-buy" v-if="$route.meta.rightShow && firstOrder">
          首单钜惠
        </div>
      </template>
    </van-nav-bar>

    <main
      :class="{
        main_body: true,
        mb0: !$route.meta.tabbar,
        notop: $route.meta.noTop,
        mt0: $route.meta.noheader,
        f2: $route.meta.f2,
        bgf: $route.meta.bgf,
      }"
    >
      <van-pull-refresh
        v-model="isLoadingPage"
        @refresh="onRefreshPage"
        :disabled="$route.meta.unpull"
      >
        <router-view ref="myComponent" />
        <!-- <keep-alive>
                    <router-view v-if="$route.meta.keepAlive"></router-view>
                </keep-alive>
                <router-view v-if="!$route.meta.keepAlive"></router-view> -->
      </van-pull-refresh>
    </main>

    <van-tabbar
      v-model="active"
      route
      v-if="$route.meta.tabbar"
      class="tabbar_bottom"
    >
      <van-tabbar-item class="home" name="home" @click="goHome"
        >云手机
        <template #icon>
          <div :class="{ active: active == 'home', normal: true }">
            <img
              :src="
                $route.name == 'home'
                  ? require('../../assets/home/yunx.png')
                  : require('../../assets/home/home.jpg')
              "
              alt=""
            />
          </div>
        </template>
      </van-tabbar-item>
      <van-tabbar-item class="news" name="news" @click="goNews"
        >发现
        <template #icon>
          <div :class="{ active: active == 'news' }">
            <img
              :src="
                $route.name == 'news'
                  ? require('../../assets/home/news_active.png')
                  : require('../../assets/home/news_normal.png')
              "
              alt=""
            />
          </div>
        </template>
      </van-tabbar-item>
      <van-tabbar-item
        class="games"
        v-if="isShowGame"
        name="games"
        @click="goGames"
        >游戏库
        <template #icon>
          <div :class="{ active: active == 'games', normal: true }">
            <img
              :src="
                $route.name == 'game.library'
                  ? require('../../assets/home/game_active.png')
                  : require('../../assets/home/game_normal.png')
              "
              alt=""
            />
          </div>
        </template>
      </van-tabbar-item>
      <!-- <van-tabbar-item
        class="yungames"
        v-if="isShowYunGame"
        name="yungames"
        @click="goYunGames"
        >秒玩
        <template #icon>
          <div :class="{ active: active == 'yungames' }">
            <img
              :src="
                $route.name == 'yun.games'
                  ? require('../../assets/home/player-a.png')
                  : require('../../assets/home/player.png')
              "
              alt=""
            />
          </div>
        </template>
      </van-tabbar-item> -->
      <van-tabbar-item class="like" name="like" @click="goUser"
        >我的
        <template #icon>
          <div :class="{ active: active == 'like' }">
            <img
              :src="
                $route.name == 'user.center'
                  ? require('../../assets/home/userx.png')
                  : require('../../assets/home/user.png')
              "
              alt=""
            />
          </div>
        </template>
      </van-tabbar-item>
    </van-tabbar>

    <!-- 订单提示 -->
    <van-popup class="yunpay" v-model="showpay">
      <div class="title">
        <img src="../../assets/yunbuy/ts.png" alt="" />
        <h3>温馨提示</h3>
      </div>
      <p style="margin-top: 1.25rem">您有一笔订单暂未支付，确定要退出吗？</p>
      <div class="btnqd">
        <van-button @click="payback">确定</van-button>
        <van-button @click="showpay = false">立即支付</van-button>
      </div>
      <div class="bgc1"></div>
    </van-popup>

    <!-- 签到 -->
    <van-popup
      @close="signInClose"
      class="sign_in"
      overlay-class="adbg"
      v-model="signInShow"
      :close-on-click-overlay="false"
      :lazy-render="false"
    >
      <div class="sign_bgc">
        <img src="../../assets/sign/sign_backg.png" alt="" />
      </div>
      <div class="sign_close">
        <img
          v-if="isShowClose"
          @click="signClose"
          src="../../assets/sign/sign_close.png"
          alt=""
        />
      </div>
      <div class="header_tips">
        <img src="../../assets/sign/tips_icon.png" alt="" />
      </div>
      <div class="step_one" v-if="stepOne">
        <div class="top_txt">
          <div>累计签到</div>
          <div class="rule" @click="goRule">
            <img src="../../assets/sign/rule_icon.png" alt="" />
          </div>
        </div>
        <div class="totalDays">
          <div v-for="day in 7" :key="day" class="step">
            <div
              class="reward"
              v-for="(item, i) in accumulateReward"
              v-show="item.day == day"
              :key="i"
              :class="{ last_reward: day == 7 }"
            >
              <span v-show="item.time">+{{ item.time / 60 }}小时</span>
              <div v-show="item.time && signedDays >= day" class="pick">
                已领取
              </div>
            </div>
            <span v-if="signedDays >= day" class="check-mark">
              <img src="../../assets/sign/leiji_icon.png" alt="" />
            </span>
            <span v-else class="check-day">{{ day }}</span>
            <span
              v-if="day < 7"
              class="line"
              :class="{ active_line: day <= signedDays }"
            ></span>
          </div>
        </div>
        <div class="sign_card">
          <div class="sign_content" v-for="(val, j) in signDetail" :key="j">
            <div
              v-for="(item, i) in signReward"
              v-show="item.day == j + 1"
              :key="i"
              class="card"
              :class="{
                sign_active: val.sign_in == 1,
                sign_unactive: val.sign_in == 0 && dayOfWeek > item.day,
              }"
            >
              <!-- <div class="times">- 第{{ item.day }}天 -</div> -->
              <div class="times">- 周{{ item.day | numberToChinese }} -</div>
              <div
                v-if="val.sign_in == 0 && dayOfWeek <= item.day"
                class="normal_img"
              >
                <vue-img :src="require('@/assets/sign/sign_gift.png')" />
              </div>
              <div v-if="val.sign_in == 1" class="sign_success">
                <div class="circle">
                  <div class="dui_icon">
                    <img src="../../assets/sign/daily_sign.png" alt="" />
                  </div>
                  <div class="circle_txt">已领取</div>
                </div>
              </div>
              <div
                v-if="val.sign_in == 0 && dayOfWeek > item.day"
                class="unclaimed"
              >
                <div class="circle">
                  <div class="warn_icon">
                    <img src="../../assets/sign/warn_icon.png" alt="" />
                  </div>
                  <div class="circle_txt">未领取</div>
                </div>
              </div>
              <div
                class="sign_reward"
                :class="{
                  sign_cg:
                    val.sign_in == 1 ||
                    (val.sign_in == 0 && dayOfWeek > item.day),
                }"
              >
                {{ item.time / 60 }}小时
              </div>
            </div>
          </div>
        </div>
        <div class="sign_btn" v-if="todaySign == 0" @click="goSignIn">
          立即签到
        </div>
        <div class="sign_complete" v-if="todaySign == 1">
          今日已签到 奖励已发放
        </div>
      </div>
      <div class="step_two" v-if="stepTwo">
        <div class="title">
          <!-- <div class="back" @click="goStepOne">
            <img src="../../assets/sign/back_icon.png" alt="" />
          </div> -->
          <div>签到说明</div>
        </div>
        <div class="content">
          <div class="txt">1. 活动期间签到或累计签到可以获得云手机时长</div>
          <div class="txt">
            2. 通过每日签到激活累计签到进度，可获得不同进度奖励
          </div>
          <div class="txt">3. 云手机时长奖励仅支持新增设备，暂不支持续时</div>
        </div>
        <div class="knows" @click="goStepOne">知道了</div>
      </div>
    </van-popup>
    <!-- 签到成功 -->
    <van-popup
      class="sign_success_pop"
      overlay-class="adbg"
      v-model="signSuccess"
      @close="signSuccessClose"
      :close-on-click-overlay="false"
    >
      <div class="sign_close" @click="signSuccess = false">
        <img src="../../assets/sign/sign_close.png" alt="" />
      </div>
      <div class="title">签到成功</div>
      <div class="detail">
        <div
          class="content"
          v-for="(item, i) in signReward"
          :key="i"
          v-show="item.day == dayOfWeek && item.time"
        >
          <!-- <div class="top">- 第{{ item.day }}天 -</div> -->
          <div class="top">- 周{{ item.day | numberToChinese }} -</div>
          <div class="center">
            <vue-img :src="require('@/assets/sign/sign_gift.png')" />
          </div>
          <div class="reward">{{ item.time / 60 }}小时</div>
        </div>
        <div
          class="add_icon"
          v-for="(item, i) in accumulateReward"
          :key="`add_${i}`"
          v-show="item.day == signedDays && item.time"
        >
          +
        </div>
        <div
          class="content"
          v-for="(item, i) in accumulateReward"
          :key="`accumulate_${i}`"
          v-show="item.day == signedDays && item.time"
        >
          <div class="top">- 累计{{ item.day }}天 -</div>
          <div class="center">
            <vue-img :src="require('@/assets/sign/sign_gift.png')" />
          </div>
          <div class="reward">{{ item.time / 60 }}小时</div>
        </div>
      </div>
      <div class="tips">{{ rewardTimes }}小时云手机已自动发放</div>
      <div class="start_btn" @click="onStart">立刻启动</div>
    </van-popup>
    <!-- 签到失败 -->
    <van-popup
      class="sign_failed_pop"
      overlay-class="adbg"
      v-model="signFailed"
      @close="signFailedClose"
      :close-on-click-overlay="false"
    >
      <div class="sign_close" @click="signFailed = false">
        <img src="../../assets/sign/sign_close.png" alt="" />
      </div>
      <div class="title">签到失败</div>
      <div class="detail">
        <div
          class="content"
          v-for="(item, i) in signReward"
          :key="i"
          v-show="item.day == dayOfWeek && item.time"
        >
          <!-- <div class="top">- 第{{ item.day }}天 -</div> -->
          <div class="top">-周{{ item.day | numberToChinese }} -</div>
          <div class="circle">
            <div class="warn_icon">
              <img src="../../assets/sign/sign_failed_icon.png" alt="" />
            </div>
            <div class="circle_txt">已失败</div>
          </div>
          <div class="reward">{{ item.time / 60 }}小时</div>
        </div>
      </div>
      <div class="tips">{{ failMsg }}</div>
      <div class="start_btn" @click="signFailed = false">稍后再试试</div>
    </van-popup>
    <!-- 广告弹框 -->
    <van-popup
      @close="adClose"
      class="adlog"
      overlay-class="adbg"
      v-model="showAd"
    >
      <div class="close">
        <img
          @click="showAd = false"
          src="../../assets/home/组 1223.png"
          alt=""
        />
      </div>
      <img @click="goAdlink" :src="adimg" alt="" />
    </van-popup>

    <!-- 新手引导 -->
    <van-popup class="xinshou" v-model="showyd">
      <div class="bgc"></div>
      <div class="one" v-if="ydimg == 0">
        <img src="../../assets/xin/组 1081.png" alt="" />
        <van-button @click="ydimg = 1">下一步</van-button>
      </div>
      <div class="two" v-if="ydimg == 1">
        <van-button @click="ydimg = 2">下一步</van-button>
        <img src="../../assets/xin/组 1082.png" alt="" />
      </div>
      <div class="three" v-if="ydimg == 2">
        <img src="../../assets/xin/组 1080.png" alt="" />
        <van-button @click="ydclose">我知道了！</van-button>
      </div>
    </van-popup>

    <!-- 订单提示 -->
    <div class="bgfeng" v-if="bgShow"></div>
    <van-popup
      :close-on-click-overlay="false"
      class="yunfeng"
      v-model="showfeng"
      :overlay="false"
    >
      <div class="title">
        <h3>账号封禁提示</h3>
      </div>
      <p style="margin-top: 1.25rem">
        由于<span style="color: #6714cc; font-weight: 700">{{
          fengdata.reason
        }}</span
        >账号被限制登录 {{ fengdata.ban_day }}，将在<van-count-down
          :time="new Date(strReplace(fengdata.ban_end_time)) - new Date()"
          format="DD 天 HH 时 mm 分 ss 秒"
          style="display: inline-block; color: #6714cc; font-weight: 700"
        ></van-count-down
        >后自动解除，如有疑问可联系官方客服咨询
      </p>
      <div class="btnqd">
        <van-button @click="fengtrue">我知道了</van-button>
      </div>
      <div class="bgc1"></div>
    </van-popup>
    <div class="iosshu" v-if="showimg1 && !$store.getters.state.isWxApp">
      <img class="img1" src="../../assets/yunbuy/12.png" alt="" />
      <div class="close1" @click="showimg1 = false"></div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { Toast } from "vant";
import { upsertLocalAccount } from "@/utils/localAccounts";
export default {
  name: "layout-main",
  computed: {
    isSafari() {
      var ua = navigator.userAgent.toLowerCase();
      if (
        ua.indexOf("applewebkit") > -1 &&
        ua.indexOf("mobile") > -1 &&
        ua.indexOf("safari") > -1 &&
        ua.indexOf("linux") === -1 &&
        ua.indexOf("android") === -1 &&
        ua.indexOf("chrome") === -1 &&
        ua.indexOf("ios") === -1 &&
        ua.indexOf("browser") === -1
      ) {
        return true;
      } else {
        return false;
      }
    },
    isLogin() {
      return this.$store.getters.isLogin;
    },
    isPc() {
      return this.$store.getters.ua.isPc;
    },
    isiOS() {
      var u = navigator.userAgent;
      if (!!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
        return true;
      } else {
        return false;
      }
    },
    isAndroid() {
      var u = navigator.userAgent;
      if (u.indexOf("Android") > -1 || u.indexOf("Adr") > -1) {
        return true;
      } else {
        return false;
      }
    },
    isIpad() {
      var ua = navigator.userAgent.toLowerCase();
      var s = ua.match(/iPad/i);
      if (s == "ipad") {
        return true;
      } else {
        return false;
      }
    },
    //服务器时间
    now() {
      return new Date(new Date().valueOf() - this.$store.state.differTime);
    },
  },
  data() {
    return {
      identityFlag: false, //是否实名
      active: "home",
      isLoadingPage: false,
      showpay: false,
      showAd: false,
      adimg: "",
      adlink: "",
      cycle_hour: "", // 广告显示周期/小时
      isApp: false,
      showyd: false, // 新手引导展示
      ydimg: 0,
      showfeng: false, // 封禁提示
      bgShow: false,
      fengdata: {},
      showimg1: false,
      firstOrder: true,
      signInShow: false,
      stepOne: true,
      stepTwo: false,
      dayOfWeek: 1, //本周第几天
      signDetail: [], //签到详情
      todaySign: 0, //今日是否签到 0未签到，1 签到
      signedDays: 0, //已签到的天数
      accumulateReward: [], //累计奖励
      signReward: [], //签到奖励
      signSuccess: false,
      signFailed: false,
      failMsg: "",
      rewardTimes: 0,
      isAdPop: true,
      isSignActive: true, //是否开启签到
      isShowClose: true,
      isShowGame: false, //是否显示游戏库
      // isShowYunGame: false, //是否显示秒玩
      loginTimer: null, //心跳检测定时器
      // list: {
      //   info: {
      //     content: [
      //       {
      //         date: "2024-02-26", //周一 日期
      //         sign_in: 1, //是否签到 0未签到，1 签到
      //       },
      //       {
      //         date: "2024-02-27",
      //         sign_in: 0,
      //       },
      //       {
      //         date: "2024-02-28",
      //         sign_in: 0,
      //       },
      //       {
      //         date: "2024-02-29",
      //         sign_in: 0,
      //       },
      //       {
      //         date: "2024-03-01",
      //         sign_in: 0,
      //       },
      //       {
      //         date: "2024-03-02",
      //         sign_in: 0,
      //       },
      //       {
      //         date: "2024-03-03",
      //         sign_in: 0,
      //       },
      //     ],
      //   },
      //   today: "2024-02-27", //当前天
      //   toWeek: "2", //当前周几 为0时为周日
      // },
    };
  },
  created() {
    var that = this;
    // web端向原生端请求获取设备信息
    try {
      window.webkit.messageHandlers.requestDeviceInfoWebToNative.postMessage(
        "xxx"
      );
    } catch (error) {
      console.log(error);
    }
    // 原生端发送设备信息到web端
    window["getDeviceInfoNativeToWeb"] = function (data) {
      // console.log("getDeviceInfoNativeToWeb:", data);
      that.$store.dispatch("setAppInfo", {
        appdeviceinfo: data,
      });

      that.$store.commit("setChannel", JSON.parse(data).channel);

      that.$store.commit("watchApp", true);
      that.isApp = true;

      // web端请求原生端是否需要展示新手引导
      try {
        window.webkit.messageHandlers.checkNeedGuideWebToNative.postMessage(
          "xxxxxx"
        );
      } catch (error) {
        console.log(error);
      }

      // 一键登录
      if (!that.isLogin) {
        try {
          window.webkit.messageHandlers.openPnsLoginWebToNative.postMessage(
            "xx"
          );
        } catch (error) {
          console.log(error);
        }
      }
    };

    // 原生端通知web端是否需要展示新手引导 "needGuide":1,//1:展示 0：不展示
    window["getGuideStatusNativeToWeb"] = function (data) {
      const obj = JSON.parse(data);
      if (obj.needGuide == 1) {
        that.showyd = true;
        // var deleteNode = document.querySelector('.my_popup')
        // document.querySelector('body').removeChild(deleteNode);
        that.showAd = false;
      }
    };

    // 原生端通知web端不支持运营商登录
    window["unsupportPnsLoginNativeToWeb"] = function (str) {
      if (str && that.$store.state.isOne == 1) {
        Toast(str);
        that.$store.commit("isOneLogin", 0);
      }
      const mypop = document.querySelector(".my_popup");
      if (!mypop) {
        that.$mypopup();
      }
    };
    // 一键登录成功 web端接收用户信息
    window["receivePnsTokenNativeToWeb"] = function (data) {
      that.$store.dispatch("setCookies", JSON.parse(data));
      Toast.success("登录成功,欢迎使用");
      setTimeout(() => {
        location.href = "/home";
      }, 0);
      // try {
      //   document
      //     .querySelector("body")
      //     .removeChild(document.querySelector(".my_popup"));
      //   document.querySelector(".van-popup__close-icon").click();
      // } catch (error) {
      //   console.log(error);
      // }
    };
  },
  mounted() {
    if (this.isLogin) {
      this.getUserInfo();
    }
    if (this.isiOS && !this.isApp && this.isSafari) {
      this.showimg1 = true;
    }
    if (
      ("standalone" in window.navigator && window.navigator.standalone) ||
      window.matchMedia("(display-mode: standalone)").matches
    ) {
      this.showimg1 = false;
    }
    // if (window.name == "") {
    //   // this.$toast("首次被加载");
    //   window.name = "isReload"; // 在首次进入页面时我们可以给window.name设置一个固定值
    //   localStorage.setItem("oneQd", true);
    // } else if (window.name == "isReload") {
    //   // this.$toast("页面被刷新");
    //   localStorage.setItem("oneQd", false);
    // }
    // const isReload = localStorage.getItem("oneQd");
    // if (isReload == "true") {
    //   if (!this.isiOS) {
    //     const userData = JSON.parse(localStorage.getItem("userData"));
    //     if (userData) {
    //       this.$store.dispatch("setCookies", userData);
    //     }
    //   }
    // }
  },
  methods: {
    handleTouchMove(event) {
      if (event.stopPropagation) {
        event.stopPropagation(); // 标准浏览器
      } else {
        event.cancelBubble = true; // IE 兼容性处理
      }
    },
    async getUserInfo() {
      await this.$Ajax("user/get-user-data").then((res) => {
        if (res.code == 1) {
          this.identityFlag = res.data.identityFlag;
          this.$store.commit("setUuid", res.data.id);
          upsertLocalAccount({
            userId: res.data.id,
            nickName: res.data.nick_name,
            phone: res.data.phone,
            headImg: res.data.head_img,
            refreshToken: this.$store.state.refreshToken,
            accessToken: this.$store.state.accessToken,
          });
        }
      });
    },
    ydclose() {
      this.showyd = false;
      this.getAdList("home");
      localStorage.setItem("homelog", 1);
    },
    goAdlink() {
      if (this.adlink.includes("http")) {
        location.href = this.adlink;
      } else {
        this.$router.push(this.adlink);
      }
      this.showAd = false;
    },
    fengtrue() {
      this.showfeng = false;
      this.bgShow = false;
      this.$router.replace("/home");
      this.$store.commit("setFeng", null);
      this.$store.dispatch("logout");
    },
    strReplace(str) {
      if (!str) return;
      var newstr = str;
      newstr = newstr.replace(/\-/g, "/");
      return newstr;
    },
    onRefreshPage() {
      var that = this;
      setTimeout(() => {
        this.$bus.$emit("refreshPage");
        that.isLoadingPage = false;
      }, 500);
    },
    goHome() {
      this.$router.push("/home");
    },
    onClickLeft() {
      if (this.$route.name == "pay") {
        // this.showpay = true;
        this.$store.commit("payClick", true);
        return;
      }
      this.$router.go(-1);
      if (localStorage.getItem("is_standalone") == "true") {
        this.$router.replace("/home");
        // this.$router.back()

        return;
      }
    },
    onClickRight() {
      if (
        this.$route.name == "group.management" ||
        this.$route.name == "group.move.target"
      ) {
        this.$store.commit("setGroup", true);
        this.$store.commit("setBgColor", true);
      }
      if (this.$route.name == "yunbuy") {
        this.$router.push({ name: "juhui" });
      }
    },
    goNews() {
      this.$router.push("/news");
    },
    goGames() {
      this.$router.push("/game/library");
    },
    // goYunGames() {
    //   this.$router.push("/yun/games");
    // },
    goUser() {
      if (!this.isLogin) {
        try {
          window.webkit.messageHandlers.openPnsLoginWebToNative.postMessage(
            "xx"
          );
        } catch (error) {
          this.$mypopup({
            onSuccess: () => {
              this.$router.replace("/user/center");
            },
          });
        }
      } else {
        this.$router.push("/user/center");
      }
    },
    payback() {
      // this.showpay = false;
      this.$router.back();
    },
    goRule() {
      this.isShowClose = false;
      this.stepOne = false;
      this.stepTwo = true;
    },
    goStepOne() {
      this.isShowClose = true;
      this.stepOne = true;
      this.stepTwo = false;
    },
    signClose() {
      this.signInShow = false;
      setTimeout(() => {
        this.stepOne = true;
        this.stepTwo = false;
      }, 500);
    },
    //签到
    goSignIn() {
      if (this.identityFlag) {
        this.isAdPop = false;
        this.$Ajax("signin/set-sign-in").then((rs) => {
          if (rs.code == 1) {
            this.$Ajax("signin/get-index").then((rs) => {
              if (rs.code == 1) {
                this.dayOfWeek = [7, 1, 2, 3, 4, 5, 6][rs.data.toWeek];
                this.signedDays = rs.data.info.content.filter(
                  (item) => item.sign_in == 1
                ).length;
                this.getSignReward(() => {
                  this.signInShow = false;
                  this.signSuccess = true;
                });
              }
            });
          } else if (rs.code == "-2") {
            this.failMsg = rs.msg;
            this.signInShow = false;
            this.signFailed = true;
          } else {
            this.$toast(rs.msg);
          }
        });
      } else {
        this.signInShow = false;
        this.$toast("您的账号未实名认证，请前往完成实名信息认证");
        this.$router.push({ name: "user.identity" });
      }
    },
    //签到成功窗口关闭事件
    signSuccessClose() {
      this.isAdPop = true;
      if (this.isAdPop) {
        if (this.$route.name == "home") {
          this.getSignRecords("home");
        } else if (this.$route.name == "user.center") {
          this.getSignRecords("mine");
        }
      }
    },
    //签到失败窗口关闭事件
    signFailedClose() {
      this.isAdPop = true;
      if (this.isAdPop) {
        if (this.$route.name == "home") {
          this.getSignRecords("home");
        } else if (this.$route.name == "user.center") {
          this.getSignRecords("mine");
        }
      }
    },
    onStart() {
      if (this.$route.name == "user.center") {
        setTimeout(() => {
          this.signSuccess = false;
          this.$router.push({ name: "home" });
        }, 500);
      } else if (this.$route.name == "home") {
        setTimeout(() => {
          this.signSuccess = false;
          this.$refs.myComponent.onReload();
        }, 500);
      }
    },
    //签到详情
    getSignRecords(type) {
      this.$Ajax("signin/get-index").then((rs) => {
        if (rs.code == 1) {
          // console.log(rs.data);
          this.dayOfWeek = [7, 1, 2, 3, 4, 5, 6][rs.data.toWeek];
          this.signedDays = rs.data.info.content.filter(
            (item) => item.sign_in == 1
          ).length;
          this.signDetail = rs.data.info.content;
          this.todaySign = rs.data.info.content.find(
            (item) => item.date === rs.data.today
          ).sign_in;
          if (this.todaySign) {
            this.signInShow = false;
            this.getAdList(type);
          } else {
            if (localStorage.getItem("signInShow") != rs.data.today) {
              this.signInShow = true;
              const today = new Date();
              const newYear = today.getFullYear();
              const newMonth = String(today.getMonth() + 1).padStart(2, "0"); // 月份从0开始，需要加1
              const newDay = String(today.getDate()).padStart(2, "0");
              const currentDay = `${newYear}-${newMonth}-${newDay}`;
              localStorage.setItem("signInShow", currentDay);
            } else {
              this.getAdList(type);
            }
          }
          this.getSignReward(() => {});
        }
      });
    },
    // 获取广告
    getAdList(type) {
      var equipments;
      if (this.isAndroid) equipments = "android";
      if (this.isPc) equipments = "pc";
      if (this.isiOS) equipments = "ios";
      if (this.isIpad) equipments = "ipad";

      this.$Ajax("index/popop-ad", {
        type,
        equipments,
      }).then((rs) => {
        if (rs.code == 1) {
          this.adimg = rs.data[0].img;
          this.adlink = rs.data[0].link;
          this.cycle_hour = rs.data[0].cycle_hour;
          const adlog = Cookies.get("adlog");
          const adlog1 = Cookies.get("adlog1");
          if (adlog != 1 && this.$route.name == "home") {
            this.showAd = true;
          } else if (adlog1 != 1 && this.$route.name == "user.center") {
            this.showAd = true;
          } else {
            // this.getSignRecords()
          }
        } else {
          // this.getSignRecords()
        }
      });
    },
    //签到奖励
    getSignReward(callback) {
      this.$Ajax("signin/reward").then((rs) => {
        if (rs.code == 1) {
          this.signReward = rs.data.sign_in_reward;
          this.accumulateReward = rs.data.accumulate_reward;
          let accumulateTimes;
          let signTimes;
          if (this.signedDays) {
            accumulateTimes =
              this.accumulateReward.filter(
                (item) => item.day == this.signedDays
              )[0].time / 60;
          } else {
            accumulateTimes = 0;
          }
          if (this.dayOfWeek) {
            signTimes =
              this.signReward.filter((item) => item.day == this.dayOfWeek)[0]
                .time / 60;
          }
          this.rewardTimes = signTimes + accumulateTimes;
        }
        callback();
      });
    },
    //关闭签到
    signInClose() {
      this.$store.commit("setSignIn", false);
      if (this.isAdPop) {
        if (this.$route.name == "home") {
          this.getAdList("home");
        } else if (this.$route.name == "user.center") {
          this.getAdList("mine");
        }
      }
    },
    // 关闭广告
    adClose() {
      let seconds = this.cycle_hour * 60 * 60;
      let expires = new Date(new Date() * 1 + seconds * 1000);
      if (this.$route.name == "home") {
        Cookies.set("adlog", 1, { expires: expires });
      } else if (this.$route.name == "user.center") {
        Cookies.set("adlog1", 1, { expires: expires });
      }
      // this.getSignRecords()
    },
  },
  filters: {
    numberToChinese(value) {
      const chineseNumbers = ["一", "二", "三", "四", "五", "六", "日"];
      return chineseNumbers[value - 1];
    },
  },
  watch: {
    isLogin: {
      immediate: true,
      async handler(val) {
        if (val) {
          await this.getUserInfo();
          this.$Ajax("/index/heartbeat").then((rs) => {
            if (rs.code == 1) {
              if (rs.data.type == 1) {
                this.$store.dispatch("triggerExitId", rs.data.cancel_instance);
              }
            }
          });
          this.loginTimer = setInterval(() => {
            this.$Ajax("/index/heartbeat").then((rs) => {
              if (rs.code == 1) {
                if (rs.data.type == 1) {
                  this.$store.dispatch(
                    "triggerExitId",
                    rs.data.cancel_instance
                  );
                }
              }
            });
          }, 60000);

          if (this.$route.name == "home") {
            await this.$Ajax("signin/get-status").then((rs) => {
              if (rs.code == 1) {
                this.isSignActive = rs.data.data;
                this.$store.commit("isSetSign", this.isSignActive);
                this.active = "home";
                if (this.isSignActive) {
                  this.getSignRecords("home");
                } else {
                  this.getAdList("home");
                }
              }
            });
          }
        } else {
          if (this.loginTimer) {
            clearInterval(this.loginTimer);
            this.loginTimer = null;
          }
        }
      },
    },
    "$route.path": {
      immediate: true,
      async handler(a) {
        const appDeviceInfo = this.$store.state.appdeviceinfo;
        if (typeof appDeviceInfo == "string" && appDeviceInfo.trim()) {
          var channel = JSON.parse(appDeviceInfo).channel;
        } else {
          var channel = Cookies.get("newPlatId");
        }
        if (channel) {
          try {
            const platData = await this.$Ajax("/game/get-plat-list");
            if (platData.code == 1) {
              var isFound = platData.data.includes(channel);
              this.isShowGame = !isFound;
              this.$store.commit("setDisabledChannel", !isFound);
            }
            const platYunData = await this.$Ajax("/smallgame/get-plat-list");
            // if (platYunData.code == 1) {
            //   var isYunFound = platYunData.data.includes(channel);
            //   this.isShowYunGame = !isYunFound;
            // }
          } catch (e) {}
        } else {
          this.isShowGame = true;
          // this.isShowYunGame = true;
        }

        if (this.isLogin) {
          if (a == "/user/center" || a == "/home") {
            await this.$Ajax("signin/get-status").then((rs) => {
              if (rs.code == 1) {
                this.isSignActive = rs.data.data;
                this.$store.commit("isSetSign", this.isSignActive);
              }
            });
          }
          if (a == "/user/center") {
            this.active = "like";
            // this.getAdList("mine");
            if (this.isSignActive) {
              this.getSignRecords("mine");
            } else {
              this.getAdList("mine");
            }
          } else if (a == "/home") {
            this.active = "home";
            // this.getAdList("home");
            if (this.isSignActive) {
              this.getSignRecords("home");
            } else {
              this.getAdList("home");
            }
            // if (localStorage.getItem("homelog") == 1) {
            //   this.getAdList("home");
            // } else {
            //   localStorage.setItem("homelog", 1);
            // }
          } else if (a == "/game/library") {
            this.active = "games";
          } else if (a == "/yun/games") {
            this.active = "yungames";
          }
        }
      },
    },
    "$store.state.showfeng": {
      immediate: true,
      handler(a) {
        if (a) {
          this.showfeng = true;
          this.bgShow = true;
          this.fengdata = a;
        } else {
          this.showfeng = false;
          this.bgShow = false;
        }
      },
      deep: true,
    },
    "$store.state.firstOrder": {
      immediate: true,
      handler(val) {
        this.firstOrder = val;
      },
    },
    "$store.state.signInShow": {
      immediate: true,
      handler(val) {
        this.signInShow = val;
      },
    },
    "$store.state.isIdentity": {
      immediate: true,
      handler(val) {
        this.identityFlag = val;
      },
    },
  },
};
</script>

<style lang="less" scoped>
#main_app {
  max-width: 600px !important;
  margin: 0 auto !important;
}
.no_color {
  background: transparent;
}
.no_color::after {
  border-bottom-width: 0;
}
:deep(.van-nav-bar__text) {
  font-size: 0.7rem;
  color: #000000;
}
.tabbar_bottom {
  padding-bottom: 0 !important;
  max-width: 600px;
  .van-tabbar-item--active {
    color: #6714cc;
  }
  .normal {
    height: 1.2rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  img {
    width: 1.2rem;
    height: auto;
    margin-bottom: 0.1rem;
  }
}
/deep/.van-tabbar--fixed {
  left: 50%;
  transform: translateX(-50%);
}
.first-buy {
  width: 3.5rem;
  height: 1rem;
  background: linear-gradient(90deg, #fe8831 0%, #ea41b9 100%);
  border-radius: 0.6rem;
  font-size: 0.6rem;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.yunpay {
  max-width: 18.5rem;
  width: 84%;
  height: 12rem;
  border-radius: 1.5rem;
  text-align: center;
  .title {
    margin-top: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      margin-top: 1.5rem;
      width: 1.7rem;
      height: 1.7rem;
    }
    h3 {
      font-size: 1rem;
      margin-top: 1.4rem;
      margin-left: 0.4rem;
    }
  }

  .btnqd {
    .van-button {
      margin: 0 0.75rem;
      margin-top: 1.3rem;
      width: 4.9rem;
      height: 1.7rem;
      padding: 0 0.6rem;
      border-radius: 1.5rem;
      &:nth-child(1) {
        width: 4.81rem;
        height: 1.6rem;
        background-color: transparent;
        border: 1px solid #000;
        color: #000;
      }
      &:nth-child(2) {
        color: #fff;
        background-image: linear-gradient(to right, #286ff8, #6714cc);
      }
    }
  }
  .bgc1 {
    width: 100%;
    height: 5rem;
    position: absolute;
    left: 0;
    bottom: 0;
    opacity: 20%;
    z-index: -1;
    background: linear-gradient(to bottom, #ffffff, #6714cc);
  }
}
/deep/.adbg {
  z-index: 2030 !important;
  max-width: 600px;
  left: auto;
}
.sign_in {
  width: 17.25rem;
  height: 25.8rem;
  padding: 0.5rem 0.7rem 0;
  z-index: 2035 !important;
  background-color: transparent;
  overflow: visible;
  // background: url("../../assets/sign/sign_backg.png") no-repeat top;
  // background-size: 100% 100%;
  .sign_bgc {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: -1;
    left: 0;
    top: 0;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .sign_close {
    width: 1.15rem;
    position: absolute;
    right: 0;
    top: -1.15rem;
    img {
      width: 100%;
    }
  }
  .header_tips {
    width: 9rem;
    margin-bottom: 0.5rem;
    img {
      width: 100%;
    }
  }
  .step_one {
    .top_txt {
      margin-bottom: 1.5rem;
      padding-left: 0.1rem;
      font-size: 0.8rem;
      color: #000000;
      display: flex;
      align-items: center;
      .rule {
        width: 0.8rem;
        margin-left: 0.2rem;
        display: flex;
        align-items: center;
        img {
          width: 100%;
        }
      }
    }
    .totalDays {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 0.6rem 1.4rem;
      .step {
        display: flex;
        align-items: center;
        position: relative;
        .reward {
          position: relative;
          white-space: nowrap;
          font-size: 0.65rem;
          color: #e20303;
          position: absolute;
          top: -100%;
          left: -25%;
          .pick {
            position: absolute;
            left: 50%;
            bottom: -250%;
            transform: translateX(-50%);
            font-size: 0.6rem;
            color: #000000;
          }
        }
        .last_reward {
          left: -90%;
        }
        .check-mark {
          width: 1rem;
          height: 1rem;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .check-day {
          width: 1rem;
          height: 1rem;
          font-size: 0.6rem;
          background: #ffffff;
          border: 0.05rem solid #6517cd;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .line {
          width: 1.3rem;
          height: 0.05rem;
          background: #848484;
        }
        .active_line {
          background: #6517cd;
        }
      }
    }
    .sign_card {
      width: 15.8rem;
      box-shadow: inset 0 0.15rem 0.3rem 0.05rem rgba(255, 255, 255, 0.16);
      border-radius: 1rem;
      border: 0.15rem solid #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      padding: 0.7rem 0;
      margin: 0 auto 0.7rem;
      .sign_content {
        .card {
          width: 3.45rem;
          margin-right: 0.3rem;
          margin-bottom: 0.2rem;
          background: #ffffff;
          border-radius: 0.45rem;
          padding: 0.3rem 0.2rem 0.2rem;
          border: 0.05rem solid #9870f8;
          text-align: center;
          .times {
            font-size: 0.6rem;
            color: #6517cd;
          }

          .normal_img {
            width: 1.75rem;
            height: 1.75rem;
            border-radius: 50%;
            overflow: hidden;
            margin: 0.5rem auto 0.55rem;
          }
          .unclaimed {
            .circle {
              width: 2.2rem;
              height: 2.2rem;
              margin: 0.35rem auto 0.25rem;
              border-radius: 50%;
              background: rgba(255, 255, 255, 0.7);
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              .warn_icon {
                height: 0.6rem;
                margin-bottom: 0.1rem;
                img {
                  width: 100%;
                  height: 100%;
                }
              }
              .circle_txt {
                font-size: 0.5rem;
                color: #000000;
              }
            }
          }
          .sign_success {
            .circle {
              width: 2.2rem;
              height: 2.2rem;
              margin: 0.35rem auto 0.25rem;
              border-radius: 50%;
              background: rgba(255, 255, 255, 0.7);
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              .dui_icon {
                width: 0.75rem;
                height: 0.6rem;
                margin-bottom: 0.1rem;
                img {
                  width: 100%;
                  height: 100%;
                }
              }
              .circle_txt {
                font-size: 0.5rem;
                color: #6517cd;
              }
            }
          }

          .sign_reward {
            padding: 0.1rem 0.5rem;
            background: #8b5aff;
            border-radius: 0.4rem;
            font-weight: 400;
            font-size: 0.5rem;
            color: #ffffff;
            display: inline-flex;
            justify-content: center;
            align-items: center;
          }
          .sign_cg {
            opacity: 0.5;
          }
        }
        .sign_active {
          background: rgba(162, 126, 248, 0.6);
        }
        .sign_unactive {
          background: rgba(132, 132, 132, 0.6);
        }
        .card:nth-child(4) {
          margin-right: 0;
        }
      }
    }
    .sign_btn {
      width: 100%;
      height: 2.2rem;
      background: linear-gradient(270deg, #6714cc 0%, #286ff8 100%);
      border-radius: 1.5rem;
      font-weight: bold;
      font-size: 0.8rem;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 1rem;
    }
    .sign_complete {
      width: 100%;
      height: 2.2rem;
      background: #b4b4b4;
      border-radius: 1.5rem;
      font-weight: bold;
      font-size: 0.8rem;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 1rem;
    }
  }
  .step_two {
    .title {
      position: relative;
      text-align: center;
      font-weight: bold;
      font-size: 0.8rem;
      color: #000000;
      margin: 1.5rem auto 1.3rem;
      .back {
        position: absolute;
        left: 0;
        top: 0;
        height: 1rem;
        img {
          height: 100%;
        }
      }
    }
    .content {
      padding-left: 0.4rem;
      margin-bottom: 2rem;
      font-size: 0.7rem;
      color: #000000;
      line-height: 1.4rem;
      text-align: left;
    }
    .knows {
      width: 100%;
      height: 2.2rem;
      background: linear-gradient(270deg, #6714cc 0%, #286ff8 100%);
      border-radius: 1.5rem;
      font-weight: bold;
      font-size: 0.8rem;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 1rem;
    }
  }
}
.sign_success_pop {
  width: 12.4rem;
  background: linear-gradient(351deg, #dfc5ff 0%, #ffffff 100%);
  text-align: center;
  border-radius: 1.45rem;
  padding: 1.45rem 0;
  border: 0.05rem solid #707070;
  z-index: 2035 !important;
  overflow: visible;
  .sign_close {
    width: 1.15rem;
    position: absolute;
    right: -0.55rem;
    top: -1.5rem;
    img {
      width: 100%;
    }
  }
  .title {
    font-weight: bold;
    font-size: 0.8rem;
    color: #e50000;
  }
  .detail {
    display: flex;
    justify-content: center;
    align-items: center;
    .add_icon {
      font-weight: bold;
      font-size: 1rem;
      color: #000000;
      margin: 0 0.4rem;
    }
    .content {
      width: 3.45rem;
      margin: 0.65rem 0;
      background: #ffffff;
      border-radius: 0.45rem;
      padding: 0.3rem 0 0.2rem;
      border: 0.05rem solid #9870f8;
      .top {
        font-size: 0.6rem;
        color: #6517cd;
      }
      .center {
        width: 1.75rem;
        height: 1.75rem;
        border-radius: 50%;
        overflow: hidden;
        margin: 0.4rem auto;
      }
      .reward {
        background: #8b5aff;
        border-radius: 0.4rem;
        font-size: 0.5rem;
        color: #ffffff;
        display: inline-flex;
        padding: 0.1rem 0.5rem;
      }
    }
  }
  .tips {
    font-size: 0.7rem;
    color: #000000;
    margin-bottom: 0.65rem;
  }
  .start_btn {
    width: 10.7rem;
    height: 1.85rem;
    margin: 0 auto;
    background: linear-gradient(270deg, #6714cc 0%, #286ff8 100%);
    border-radius: 1.5rem;
    font-weight: bold;
    font-size: 0.8rem;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.sign_failed_pop {
  width: 12.4rem;
  background: linear-gradient(351deg, #dfc5ff 0%, #ffffff 100%);
  text-align: center;
  border-radius: 1.45rem;
  padding: 1.45rem 0;
  border: 0.05rem solid #707070;
  z-index: 2035 !important;
  overflow: visible;
  .sign_close {
    width: 1.15rem;
    position: absolute;
    right: -0.55rem;
    top: -1.5rem;
    img {
      width: 100%;
    }
  }
  .title {
    font-weight: bold;
    font-size: 0.8rem;
    color: #000000;
  }
  .detail {
    display: flex;
    justify-content: center;
    align-items: center;
    .add_icon {
      font-weight: bold;
      font-size: 1rem;
      color: #000000;
      margin: 0 0.4rem;
    }
    .content {
      width: 3.45rem;
      margin: 0.65rem 0;
      border-radius: 0.45rem;
      padding: 0.3rem 0 0.2rem;
      border: 0.05rem solid #9870f8;
      background: rgba(132, 132, 132, 0.6);
      .top {
        font-size: 0.6rem;
        color: #6517cd;
      }
      .circle {
        width: 2.2rem;
        height: 2.2rem;
        margin: 0.35rem auto 0.25rem;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.7);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .warn_icon {
          height: 0.75rem;
          margin-bottom: 0.1rem;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .circle_txt {
          font-size: 0.5rem;
          color: #000000;
        }
      }
      .reward {
        background: #8b5aff;
        border-radius: 0.4rem;
        font-size: 0.5rem;
        color: #ffffff;
        display: inline-flex;
        padding: 0.1rem 0.5rem;
        opacity: 0.5;
      }
    }
  }
  .tips {
    font-size: 0.7rem;
    color: #000000;
    margin-bottom: 0.65rem;
  }
  .start_btn {
    width: 10.7rem;
    height: 1.85rem;
    margin: 0 auto;
    background: linear-gradient(270deg, #6714cc 0%, #286ff8 100%);
    border-radius: 1.5rem;
    font-weight: bold;
    font-size: 0.8rem;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.adlog {
  width: 80%;
  max-width: 480px;
  // min-height: 14.5rem;
  background-color: transparent;
  overflow: inherit;
  z-index: 2035 !important;
  .close {
    position: absolute;
    right: 0;
    top: -1.3rem;
    img {
      width: 1rem;
    }
  }
  img {
    width: 100%;
    height: 100%;
    border-radius: 0.5rem;
  }
}

.xinshou {
  width: 100vw;
  height: 100vh;
  background-color: transparent;
  padding: 0 1.25rem;
  .bgc {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
    opacity: 0.3;
    z-index: -1;
  }
  .one {
    margin-top: 19.4rem;
    text-align: center;
    img {
      width: 100%;
    }
    .van-button {
      width: 6.5rem;
      height: 1.75rem;
      border: 1px solid #fff;
      background-color: transparent;
      margin-top: 2.85rem;
      border-radius: 2rem;
      color: #fff;
    }
  }

  .two {
    margin-top: 16.4rem;
    text-align: center;
    img {
      width: 100%;
      height: 100%;
      margin-top: 1.85rem;
    }
    .van-button {
      margin-top: 1rem;
      width: 6.5rem;
      height: 1.75rem;
      border: 1px solid #fff;
      background-color: transparent;
      border-radius: 2rem;
      color: #fff;
    }
  }

  .three {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    img {
      width: 8.2rem;
      margin-top: 0.7rem;
      margin-right: -0.5rem;
    }
    .van-button {
      justify-content: center;
      width: 6.5rem;
      height: 1.75rem;
      border: 1px solid #fff;
      background-color: transparent;
      margin-top: 2.35rem;
      border-radius: 2rem;
      color: #fff;
      margin-right: 0.8rem;
    }
  }
}

.bgf {
  background-color: #fff;
}
.bgfeng {
  max-width: 600px;
  position: fixed;
  z-index: 4000;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.68);
}
.yunfeng {
  z-index: 4050 !important;
  width: 17rem;
  height: 13.4rem;
  border-radius: 1.5rem;
  text-align: center;

  .title {
    margin-top: 0.7rem;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      margin-top: 1.5rem;
      width: 1.7rem;
      height: 1.7rem;
    }
    h3 {
      font-size: 1rem;
      margin-top: 1.4rem;
      margin-left: 0.4rem;
    }
  }
  p {
    padding: 0 1.15rem;
    text-align: start;
    line-height: 1.2rem;
    color: #707070;
  }
  .btnqd {
    .van-button {
      margin: 0 0.75rem;
      margin-top: 1rem;
      width: 11.3rem;
      height: 2.5rem;
      padding: 0 0.6rem;
      border-radius: 1.5rem;
      color: #fff;
      font-size: 0.75rem;
      background: linear-gradient(to left, #6714cc, #286ff8 100%);
    }
  }
  .bgc1 {
    width: 100%;
    height: 5rem;
    position: absolute;
    left: 0;
    bottom: 0;
    opacity: 20%;
    z-index: -1;
    background: linear-gradient(to bottom, #ffffff, #6714cc);
  }
}

.iosshu {
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 9998;
  .img1 {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 80%;
  }
  .close1 {
    position: absolute;
    width: 1rem;
    height: 1rem;
    right: 2.2rem;
    bottom: 5.5rem;
    background-color: transparent;
  }
}
</style>
